declare global {
    interface Window {
        analytics: null
    }
}

function identify(): void {}

function track(_eventName: string, _traits?: Record<string, unknown>): void {}

function trackPage(): void {}

export { track, identify, trackPage }
